{
	"termsAndConditions": {
		"title": "Algemene voorwaarden",
		"submitTitle": "Accepteren en doorgaan naar het privacybeleid"
	},
	"privacyPolicy": {
		"title": "Privacybeleid",
		"submitTitle": "Accepteren en sluiten",
		"backTitle": "Terug"
	}
}
